import { client } from 'api/baseApi.ts';
import axios from 'axios';
import { APIConfigData } from 'core/config/APIConfigData';
import { formatProratedPriceData, formatSubscriptionPlanData } from 'core/utils/utils';
import apiHandler from 'api/handlers/apiHandler.ts';
import { subscriptionEndpoints } from 'api/rtk-endpoints/SubscriptionEndpoints.ts';

export const getCreditOptionsService = () =>
	new Promise((resolve, reject) => {
		axios({
			method: 'GET',
			url: `${APIConfigData.RENDERNET_BASE_URL}/v2/credits/options`,
			headers: { 'Content-Type': 'application/json' },
		})
			.then((res) => {
				const { data } = res.data;
				const { prices } = data;
				const creditOptions = prices.map((p) => {
					const {
						highlighted,
						subtext,

						credits: creditsOptions,
						price: priceOptions,
					} = p;

					const { current: credits } = creditsOptions;
					const {
						current: currentPrice,
						pre_discount: preDiscountPrice,
						discount_percent: discountPercent,
					} = priceOptions;

					const discountedPrice = currentPrice / 100;
					const originalPrice = preDiscountPrice / 100;

					return {
						highlighted,
						subtext,

						credits,

						discountedPrice,
						originalPrice,
						discountPercent,
					};
				});

				resolve(creditOptions);
			})
			.catch((error) => {
				if (!error?.code === 'ERR_CANCELED') reject(error.response?.data);
				reject(error?.response?.data);
			});
	});

export const getOneTimePaymentLinkService = async ({ value, successUrl, cancelUrl }) => {
	const request = {
		value,
		success_url: successUrl,
		cancel_url: cancelUrl,
	};
	try {
		const response = await client.credits.purchase(request);
		const { payurl: payUrl } = response.data;
		return payUrl;
	} catch (error) {
		if (!error?.code === 'ERR_CANCELED') throw error.response?.data;
		throw error?.response?.data;
	}
};

export const getSubscriptionPlansService = async ({ dispatch }) => {
	try {
		const response = await apiHandler({
			endpoint: subscriptionEndpoints.endpoints.listPlans.initiate,
			dispatch,
		});
		const plans = response.data;
		return Object.keys(plans).reduce((acc, planType) => {
			acc[planType] = plans[planType].map((plan) => formatSubscriptionPlanData(plan));
			return acc;
		}, {});
	} catch (e) {
		if (e?.code !== 'ERR_CANCELED') throw e;
		throw new Error(e?.message);
	}
};

export const getProratedSubscriptionPriceService = async (
	price,
	planType,
	successUrl,
	cancelUrl,
) => {
	const request = {
		price,
		subscription_type: planType,
		success_url: successUrl,
		cancel_url: cancelUrl,
	};
	try {
		const response = await client.subscription.listUpgradePlans(request);
		const plans = response.data;
		return {
			...formatProratedPriceData(plans[planType][0]),
			planType,
		};
	} catch (error) {
		if (!error?.code === 'ERR_CANCELED') throw error.response?.data;
		throw error?.response?.data;
	}
};

export const getSubscriptionPaymentLinkService = async (
	price,
	subscriptionType,
	successUrl,
	cancelUrl,
) => {
	const request = {
		price, // in cents
		subscription_type: subscriptionType,
		success_url: successUrl,
		cancel_url: cancelUrl,
	};
	try {
		const response = await client.subscription.purchase(request);
		const { pay_url: payUrl, transaction_status: transactionStatus } = response.data;
		return { payUrl, price, transactionStatus };
	} catch (e) {
		if (e?.code !== 'ERR_CANCELED') throw e;
		throw new Error(e?.message);
	}
};
// export const getSubscriptionPaymentLinkService = (price, subscriptionType, successUrl, cancelUrl) =>
// 	new Promise((resolve, reject) => {
// 		axios({
// 			method: 'POST',
// 			url: `${APIConfigData.RENDERNET_BASE_URL}/v3/subscription/purchase`,
// 			data: {
// 				price, // in cents
// 				subscription_type: subscriptionType,
// 				success_url: successUrl,
// 				cancel_url: cancelUrl,
// 			},
// 		})
// 			.then((res) => {
// 				const { data } = res.data;
// 				const { pay_url: payUrl, transaction_status: transactionStatus } = data;
// 				resolve({ payUrl, price, transactionStatus });
// 			})
// 			.catch((error) => {
// 				if (!error?.code === 'ERR_CANCELED') reject(error.response?.data);
// 				reject(error?.response?.data.err);
// 			});
// 	});

export const getManageSubscriptionLinkService = async (returnUrl) => {
	const request = { return_url: returnUrl };
	try {
		const response = await client.subscription.manage(request);
		const { url: redirectUrl } = response.data;
		return redirectUrl;
	} catch (e) {
		if (e?.code !== 'ERR_CANCELED') throw e;
		throw new Error(e?.message);
	}
};

export const validateSubscriptionCouponCodeService = async (couponCode) => {
	try {
		const request = { code: couponCode };
		const response = await client.coupon.validate(request);
		const { discount_percentage: discountPercentage, valid, message } = response;
		return {
			valid,
			discountPercentage,
			message,
			couponCode,
		};
	} catch (error) {
		if (error?.code !== 'ERR_CANCELED') throw error.response?.data?.err;
		throw new Error(error?.message);
	}
};
